import angular from 'angular'
const listPage = require('./view/list.html')
const poolListCtrl = require('./list')
const tax3DetailPage = require('./view/tax3InvoiceDetail.html')
const tax4DetailPage = require('./view/tax4InvoiceDetail.html')
const constructionDetailPage = require('./view/constructionDetail.html')
const realEstateDetailPage = require('./view/realEstateDetail.html')
const detailCtrl = require('./detailCtrl')
const relatedBillPage = require('./view/relatedBill_invoice.html')
const relatedBillCtrl = require('./openedRelatedBillCtrl')
const synInvoicePage = require('./view/synInvoiceModal.html')
const synInvoiceCtrl = require('./synInvoiceCtrl')
const synProgressPage = require('./view/synProgress.html')
const synProgressCtrl = require('./synProgressCtrl')
const downloadProgressPage = require('./view/downloadProgress.html')
const downloadProgressCtrl = require('./downloadProgressCtrl')
const statusProgressPage = require('./view/statusProgress.html')
const statusProgressCtrl = require('./statusProgressCtrl')
const chooseUkeyModalCtrl = require('./chooseUkeyModal')
const config = ($stateProvider) => {
    $stateProvider
        .state('outputManage.invoicePool.outputInvoicePool', {
            abstract: true,
            url: '/outputInvoicePool',
            template: '<div ui-view></div>',
            default: 'outputManage.invoicePool.outputInvoicePool.list',
        })
        .state('outputManage.invoicePool.outputInvoicePool.list', {
            url: '/list',
            template: listPage,
            controller: 'poolListCtrl',
            title: '销项发票池',
        })
        .state('outputManage.invoicePool.outputInvoicePool.tax3Detail', {
            url: '/tax3Detail/:invoiceId/:invType',
            template: tax3DetailPage,
            controller: 'detailCtrl',
            title: '发票预览',
            params: {
                detailFlag: true,
            },
        })
        .state('outputManage.invoicePool.outputInvoicePool.tax4Detail', {
            url: '/tax4Detail/:invoiceId/:invType',
            template: tax4DetailPage,
            controller: 'detailCtrl',
            title: '发票预览',
            params: {
                detailFlag: true,
            },
        })
        .state('outputManage.invoicePool.outputInvoicePool.constructionDetail', {
            url: '/constructionDetail/:invoiceId/:invType',
            template: constructionDetailPage,
            controller: 'detailCtrl',
            title: '发票预览',
            params: {
                detailFlag: true,
            },
        })
        .state('outputManage.invoicePool.outputInvoicePool.realEstateDetail', {
            url: '/realEstateDetail/:invoiceId/:invType',
            template: realEstateDetailPage,
            controller: 'detailCtrl',
            title: '发票预览',
            params: {
                detailFlag: true,
            },
        })
        .state('outputManage.invoicePool.outputInvoicePool.relatedBill', {
            url: '/relatedBill/:invoiceId/:invType',
            template: relatedBillPage,
            controller: 'relatedBillCtrl',
            title: '关联销售单',
        })
        .state('outputManage.invoicePool.outputInvoicePool.synInvoice', {
            url: '/synInvoice',
            template: synInvoicePage,
            controller: 'synInvoiceCtrl',
            title: '发票同步',
        })
        .state('outputManage.invoicePool.outputInvoicePool.synProgress', {
            url: '/synProgress',
            template: synProgressPage,
            controller: 'synProgressCtrl',
            title: '发票同步-进度条',
        })
        .state('outputManage.invoicePool.outputInvoicePool.downloadProgress', {
            url: '/downloadProgress',
            template: downloadProgressPage,
            controller: 'downloadProgressCtrl',
            title: '发票下载-进度条',
        })
        .state('outputManage.invoicePool.outputInvoicePool.statusProgress', {
            url: '/statusProgress',
            template: statusProgressPage,
            controller: 'statusProgressCtrl',
            title: '状态更新-进度条',
        })
}
export default angular
    .module('outputManage.invoicePool.outputInvoicePool', [])
    .config(['$stateProvider', config])
    .controller('poolListCtrl', poolListCtrl.default)
    .controller('detailCtrl', detailCtrl.default)
    .controller('synInvoiceCtrl', synInvoiceCtrl.default)
    .controller('synProgressCtrl', synProgressCtrl.default)
    .controller('downloadProgressCtrl', downloadProgressCtrl.default)
    .controller('statusProgressCtrl', statusProgressCtrl.default)
    .controller('chooseUkeyModalCtrl', chooseUkeyModalCtrl.default)
    .controller('relatedBillCtrl', relatedBillCtrl.default).name



// WEBPACK FOOTER //
// ./src/app/outputManage/invoicePool/outputInvoicePool/index.js